import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';

@Entity()
export class KPFMultipleAspect extends AbstractAspect {
  static override _class = 'KPFMultipleAspect';

  constructor(doc: PartialEntityData<KPFMultipleAspect>) {
    const newDoc = { customID: 'kpfsMultiple', ...doc };
    super(newDoc);
  }

  @Field(() => [ID]) values: Maybe<string[]>;
  @Field(() => [String]) kuerzel: Maybe<string[]>;
}
